
import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DownloadService } from '../../../shared/services/html-png/html-png.service';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent implements OnInit {
  constructor(
    public htmlPngService: DownloadService,
    @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<PopupComponent>
  ) { }

  ngOnInit() {
    this.data.val.assocs.sort(this.alphabeticallyArrange("name"))
  }

  alphabeticallyArrange(property) {
    var sortOrder = 1;

    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a,b) {
        if(sortOrder == -1){
            return b[property].localeCompare(a[property]);
        }else{
            return a[property].localeCompare(b[property]);
        }        
    }
  }

  pngDownload(chartName, elementId) {
    this.htmlPngService.downloadPng(chartName, elementId,'','','');
  }


  cancel() {
    this.dialogRef.close('Cancel');
  }
}